import * as s from '~js/utils/selectors';
import * as a from '~js/utils/attributes';
import * as c from '~js/utils/classes';

export class LoadVideoVimeo {
  constructor(container) {
    this.container = container;
    this.player = this.container.querySelector(s.selectors$13.videoIframe);

    if (this.player) {
      this.videoID = this.player.getAttribute(a.attributes$I.dataVideoId);
      this.videoType = this.player.getAttribute(a.attributes$I.dataVideoType);
      this.enableBackground = this.player.getAttribute(a.attributes$I.dataEnableBackground) === 'true';
      this.disableSound = this.player.getAttribute(a.attributes$I.dataEnableSound) === 'false';
      this.enableAutoplay = this.player.getAttribute(a.attributes$I.dataEnableAutoplay) !== 'false';
      this.enableLoop = this.player.getAttribute(a.attributes$I.dataEnableLoop) !== 'false';

      if (this.videoType == 'vimeo') {
        this.init();
      }
    }
  }

  init() {
    this.loadVimeoPlayer();
  }

  loadVimeoPlayer() {
    const oembedUrl = 'https://vimeo.com/api/oembed.json';
    const vimeoUrl = 'https://vimeo.com/' + this.videoID;
    let paramsString = '';
    const state = this.player;

    const params = {
      url: vimeoUrl,
      background: this.enableBackground,
      muted: this.disableSound,
      autoplay: this.enableAutoplay,
      loop: this.enableLoop,
    };

    for (let key in params) {
      paramsString += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&';
    }

    fetch(`${oembedUrl}?${paramsString}`)
      .then((response) => response.json())
      .then(function (data) {
        state.innerHTML = data.html;

        setTimeout(function () {
          state.parentElement.classList.add(c.classes$T.loaded);
        }, 1000);
      })
      .catch(function () {
        console.log('error');
      });
  }
}